import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { AvatarModule } from '@libs/src/avatar/avatar.module';

import { NotificationsService } from './notifications.service';

import { NotificationItemComponent } from './notification-item.component';
import { NotificationsComponent } from './notifications.component';

import { CoreModule } from '../core/core.module';
import { TimeAgoModule } from '../core/time-ago.module';
import { ProgressSpinnerModule } from '../progress-spinner/progress-spinner.module';

@NgModule({
  imports: [
    AvatarModule,
    CoreModule,
    CommonModule,
    FlexLayoutModule,
    RouterModule.forChild([
      {
        path: '',
        component: NotificationsComponent,
      },
    ]),
    ProgressSpinnerModule,
    TimeAgoModule,
  ],
  declarations: [NotificationItemComponent, NotificationsComponent],
  providers: [NotificationsService],
})
export class NotificationsModule {}
